export default {
  id: null,
  amount_in_currency: null,
  currency: "PLN",
  payment_type: null,
  payment_date: null,
  comment: null,
  files: []
};
